export default __webpack_public_path__ + "static/media/NanumSquareB.6e5f5d75.eot";